import { Env, env } from 'core/config';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { useRecoilState } from 'recoil';
import { flagsAtom } from './atoms';
import { useEffect } from 'react';
import { Flags } from './constants';

export const useFlag = (flag: string) => {
  const flagEnabled = useFeatureFlagEnabled(flag);

  return flagEnabled;
};

export const useFlagGlobally = (flag: Flags) => {
  const flagEnabled = useFlag(flag);
  const [flags, setFlags] = useRecoilState(flagsAtom);

  useEffect(() => {
    setFlags((prev) => {
      return { ...prev, [flag]: !!flagEnabled };
    });
  }, [flag, flagEnabled]);

  if (env.STAGE === Env.dev) return true;

  return flags?.[flag] ?? false;
};
